import React, { FC, useEffect } from 'react';

import { Typography } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';

import Button from '~/components/atoms/buttons/Button';
import Image from '~/components/atoms/Image';
import TransLineBreak from '~/components/atoms/TransLineBreak';
import { useIsViewport, Viewports } from '~/hooks/useIsViewport';
import PlayImg from '~/modules/cancellation/features/pause/assets/play.png';
import analytics from '~/services/analytics';
import { useAppSelector } from '~/store/hooks/useAppSelector';
import { Typographies } from '~/theme/typography';

import styles from './styles.module.scss';

type Props = {
  onClose: () => void;
};

const UnpauseSuccessModal: FC<Props> = ({ onClose }) => {
  const profile = useAppSelector((state) => state.profile);
  const isDesktop = useIsViewport(Viewports.EXTRA_SMALL_DESKTOP);

  const { t } = useTranslation('modal');

  useEffect(() => {
    analytics.trackEvent('holiday pause - unpause success modal view', {
      subscription_id: profile.user_subscription.id,
    });
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.img}>
        <Image src={PlayImg} preview={PlayImg} />
      </div>

      <Typography
        variant={Typographies.TITLE_LARGE}
        component="div"
        className={styles.title}
      >
        {t(
          'unpause_sub_success.title_v2',
          'Welcome back from your summer break!',
        )}
      </Typography>

      <Typography
        variant={Typographies.BODY_LARGE}
        component="div"
        className={styles.text}
      >
        <Trans
          i18nKey="unpause_sub_success.text_v2"
          values={{ product_name: profile.user_product.name }}
          components={{ br: <TransLineBreak /> }}
          defaults="Welcome back! Your {{product_name}} is active again with all your chats and preferences saved.<br/><br/>Let's make this semester your best yet!"
        />
      </Typography>

      <Button
        variant="contained"
        color="primary"
        fullWidth={!isDesktop}
        onClick={onClose}
      >
        {t('general:got_it', 'Got it')}
      </Button>
    </div>
  );
};

export default UnpauseSuccessModal;
